/* tagging */

import { leasingFiltersTaggingEvents } from './event-manager/config/leasing-filters-config';
import { tngTaggingEventNC, tngTaggingEventSC, tngTaggingEventUC } from './event-manager/config/tnga-config';

export interface ITaggingEventNodes {
  event: Record<string, string | null>;
  workflow?: Record<string, string | null>;
}
export interface ITaggingObject {
  t1: Record<string, string | null>;
  tnga: Record<string, string | null>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const businessEventsUC: Record<string, any> = {
  initWidget: 'TIM_WIDGET_INIT',
  closeWidget: 'TIM_WIDGET_CLOSE',
  closeWidgetAfterTagging: 'TIM_WIDGET_CLOSE_ON_TAGGING_END',
  widgetClosed: 'TIM_WIDGET_CLOSED',
  offerChosen: 'TIM_WIDGET_OFFER_CONFIRM',
  deductibleChosen: 'TIM_WIDGET_DEDUCTIBLE_CONFIRM',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const businessEventsNC: Record<string, any> = {
  initWidget: 'TIM_WIDGET_INIT',
  closeWidget: 'hide-build-amd-modal',
  closeWidgetNCXButton: 'bss-destroy-connector-event',
  closeWidgetAfterTagging: 'TIM_WIDGET_CLOSE_ON_TAGGING_END',
  widgetClosed: 'TIM_WIDGET_CLOSED',
  offerChosen: 'TIM_WIDGET_OFFER_CONFIRM',
};

export const updateWidget = 'calculator-configuration-update';

export interface ITaggingOffersEvents {
  name: string;
  data?: Record<string, Record<string, boolean> | IInsurance | string> | null;
  tagging?: boolean;
}

export interface IInsuranceSettings {
  calculationname?: string;
  currentvalue?: string | number | boolean | Date | null;
}

export interface IInsurance {
  products?: Array<Record<string, string | number>>;
  settings?: Array<IInsuranceSettings>;
}

export interface ITaggingEvents {
  name: string;
  data?: Record<string, Record<string, boolean> | IInsurance | string> | null;
  tagging?: boolean;
}

export const taggingEventsUC: Record<string, Record<string, ITaggingEventNodes>> = {
  tnga: tngTaggingEventUC,
};

export const taggingEventsNC: Record<string, Record<string, ITaggingEventNodes>> = {
  tnga: tngTaggingEventNC,
};

export const taggingEventLeasingFilters: Record<string, Record<string, ITaggingEventNodes>> = {
  tnga: leasingFiltersTaggingEvents,
};

export const taggingEventsSC: Record<string, Record<string, ITaggingEventNodes>> = {
  tnga: tngTaggingEventSC,
};
